exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".WhiteSpace_space_3bAtq {\n  padding: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"space": "WhiteSpace_space_3bAtq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/WhiteSpace.css
// module id = 978
// module chunks = 0